/**
 * Helper: SVG map
 * -----------------------------------------------------------------------------
 * Store for SVG icon paths to use in render functions.
 * - Use SVGOMG to compress files.
 * - Remove any inline fill colours.
 * - Add closing tags to suppress warnings on HTML5 compatibility.
 * - Add correct BEM class names.
 */
const minus = "\n  <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon__minus\" viewBox=\"0 0 36 36\">\n    <path d=\"M10 16h16v4H10z\"></path>\n  </svg>\n";
const plus = "\n  <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon__plus\" viewBox=\"0 0 36 36\">\n    <path d=\"M16 10v6h-6v4h6v6h4v-6h6v-4h-6v-6h-4z\"></path>\n  </svg>\n";
const close = "\n  <svg class=\"icon icon__close\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z\"/>\n  </svg>\n";
export const misc = {
  minus,
  plus,
  close
};